
























































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Confirmation extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: 'Confirmación' }) titulo!: string;
  @Prop({ default: 'Esta seguro de ...' }) mensaje!: string;
  @Prop({ default: 'Aceptar' }) textoBtnSi!: string;
  @Prop({ default: 'Cancelar' }) textoBtnNo!: string;
  @Prop({ default: '#526da5' }) siClass!: string;
  @Prop({ default: 'error' }) noClass!: string;
  @Prop({ default: 380 }) width!: number;
  @Prop({ default: true }) mostrarBoton: boolean;
  @Prop({}) testId!: string;
  @Prop() items!: string[];

  dialog: boolean = false;

  @Watch('show')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    this.dialog = value;
  }

  closeModal(val: boolean) {
    this.$emit('modalConfirmationEmit', val);
    this.dialog = false;
  }
}
